
import React, { useState, useEffect } from 'react';
import advSearchState from 'Stores/advSearch';
import { observer } from 'mobx-react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import CheckBox from 'Components/common/CheckBox';
import { userDetail } from 'Stores/userDetail';
import { InputBoxWithoutSuggestion } from '../shared-component/inputBoxWithoutSuggestion';

const LeadTitle = observer(props => {
  const blockedKey = 'title';
  const [inputVal, setInputVal] = useState('');
  const { filterInPage = false } = props;

  const [suggestionKey, setSuggestionKey] = useState('title');

  let currentSelectedState;
  if (filterInPage) currentSelectedState = advSearchState;
  else currentSelectedState = advSearchFilterPopupState;

  const { checkBoxFilters, isExcludeTitleFilter } = currentSelectedState;
  const { exactTitleMatch } = checkBoxFilters;

  const exactMatch = exactTitleMatch;

 

  const checkBoxClick = e => {
    console.log('exactMatch ', exactMatch);
    currentSelectedState.setCheckBoxFilters('exactTitleMatch');
  };

  const includeExcludeToggleCbk = () => {
    currentSelectedState.setIsExcludeTitleFilter(!isExcludeTitleFilter);
  };

  useEffect(() => {
    if (isExcludeTitleFilter) setSuggestionKey('excludeTitle');
    else setSuggestionKey('title');
  }, [isExcludeTitleFilter]);

  return (
    <div className="input-section lead-title check-box-wrap">
      <InputBoxWithoutSuggestion
        inputVal={inputVal}
        placeholder="Title"
        setInputVal={setInputVal}
        suggestionKey={suggestionKey}
        blockedKey={blockedKey}
        isExcludeEnabled={isExcludeTitleFilter}
        includeExcludeToggleCbk={includeExcludeToggleCbk}
        excludeToolTipInfo='Toggle here to include or exclude set of titles. Check "Find exact match" to include specific title.'
        {...props}
      />
      {!isExcludeTitleFilter && (
        <div
          className={`title-checkbox${exactMatch ? ' selected' : ''}`}
          onClick={checkBoxClick}
          style={{ height: '17px' }}
        >
          <div className="check-box">
            <CheckBox dymamicClass={exactMatch ? 'selected' : ''} />
          </div>
          <span className="check-box-label">Find exact matches only</span>
        </div>
      )}
    </div>
  );
});

export { LeadTitle };
export default LeadTitle;
